// extracted by mini-css-extract-plugin
module.exports = {"services":"zakres-uslug_services__1ut2Z","h1":"zakres-uslug_h1__2gm_M","h3":"zakres-uslug_h3__BLHnM","description":"zakres-uslug_description__1Ofan","p":"zakres-uslug_p__vfZwH"};